import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {UmpireProductCategory} from '@tisa-group/models';
import {
  CrudService,
  deserialize,
  JsonApiParams,
  JsonApiResponse,
  objectToHttpParams,
  serialize,
} from '@tisa-group/cdk';
import {TisaUmpireHttpService} from '../tisa-umpire-http.service';

@Injectable({
  providedIn: 'root',
})
export class ProductCategoryService implements CrudService<UmpireProductCategory> {
  constructor(readonly http: TisaUmpireHttpService) {}

  list(params?: JsonApiParams): Observable<JsonApiResponse<UmpireProductCategory[]>> {
    return this.http
      .get(`/products/categories`, {
        params: objectToHttpParams(params),
      })
      .pipe(deserialize());
  }

  delete(id: string, params?: JsonApiParams): Observable<void> {
    return this.http.delete(`/products/categories/${id}`, {
      params: objectToHttpParams(params),
    });
  }

  create(
    body: Partial<UmpireProductCategory>,
    params?: JsonApiParams,
  ): Observable<JsonApiResponse<UmpireProductCategory>> {
    return this.http
      .post<JsonApiResponse<UmpireProductCategory>>(
        '/products/categories',
        serialize({stuff: body}),
        {
          params: objectToHttpParams(params),
        },
      )
      .pipe(deserialize());
  }

  update(
    body: Partial<UmpireProductCategory>,
    params?: JsonApiParams,
  ): Observable<JsonApiResponse<UmpireProductCategory>> {
    return this.http
      .patch<JsonApiResponse<UmpireProductCategory>>(
        `/products/categories/${body.id}`,
        serialize({stuff: body}),
        {
          params: objectToHttpParams(params),
        },
      )
      .pipe(deserialize());
  }

  fetch(
    fetchIdentifier: string,
    params?: JsonApiParams,
  ): Observable<JsonApiResponse<UmpireProductCategory>> {
    return this.http
      .get(`/products/categories/${fetchIdentifier}`, {
        params: objectToHttpParams(params),
      })
      .pipe(deserialize());
  }
}
